import type { Except } from '@festina-life/core'
import type { ComponentProps } from 'react'

import { LifeCommitmentSaveOrCreateScenarioModalManager } from './LifeCommitmentSaveOrCreateScenarioModalManager'

type Props = Except<
  ComponentProps<typeof LifeCommitmentSaveOrCreateScenarioModalManager>,
  'onSubmitScenarioSuccess' | 'shouldCloseOnSuccess'
>

export const PretendCommandOutsideScenariosModalManager = (props: Props) => (
  <LifeCommitmentSaveOrCreateScenarioModalManager
    shouldCloseOnSuccess={false}
    {...props}
  />
)
